import React from "react";
import Image1920x156 from "../img/thumb/photo-1920x156--2.jpg";
import IconYoutube from "../img/icons/icon-youtube.svg";
import IconFacebook from "../img/icons/icon-facebook.svg";
import IconTwitter from "../img/icons/icon-twitter.svg";
import IconInstagram from "../img/icons/icon-instagram.svg";
import IconLinkedin from "../img/icons/icon-linkedin.svg";
import IconEmail from "../img/icons/icon-email.svg";
import IconLocation from "../img/icons/icon-location.svg";
import IconPhone from "../img/icons/icon-phone.svg";
import IconFax from "../img/icons/icon-fax.svg";
import {Config} from "../Config";

export default function Contact(prop) {

    let [data, setData] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const resView = await getContact();

                if(prop !== null && prop.lang === 'en') {
                    resView.title = resView.title_en;
                    resView.address = resView.address_en;
                }

                setData(resView);
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getContact() {
        const response = await fetch(Config.apiUrl +'contact/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                <img src={Image1920x156} alt="" />
                <div className="container">
                    <p data-aos="fade-in"><a href={prop.lang === 'en' ? '/en':'/'}>{prop.lang === 'en' ? 'Home':'หน้าแรก'}</a> / {prop.lang === 'en' ? 'Contact Us':'ติดต่อเรา'}</p>
                    <h1 className="h2 textrow">
                        <span data-aos="fade-in">{prop.lang === 'en' ? 'Contact Us':'ติดต่อเรา'}</span>
                    </h1>
                </div>
            </div>

            <div className="section bg-light">
                <div className="container">
                    <div className="article fs-16 pe-lg-4" data-aos="fade-in">
                        <h2 className="title-underline">{data?.title}</h2>

                        <ul className="contact-list">
                            <li className="align-top">
                                <div className="icon-circle">
                                    <img className="icons svg-js" src={IconLocation} alt="" />
                                </div>
                                <p dangerouslySetInnerHTML={{__html: data?.address.replace(/\n/g, "<br />")}}></p>
                            </li>

                            {
                                data?.phone ?
                                    <li>
                                        <div className="icon-circle">
                                            <img className="icons svg-js" src={IconPhone} alt="" />
                                        </div>
                                        <p>{data?.phone} {prop.lang === 'en' ? '(Contact during business hours)':'(ติดต่อเวลาทำการ)'}</p>
                                    </li> : ''
                            }

                            {
                                data?.fax ?
                                    <li>
                                        <div className="icon-circle">
                                            <img className="icons svg-js" src={IconFax} alt="" />
                                        </div>
                                        <p>{data?.fax}</p>
                                    </li> : ''
                            }

                            {
                                data?.email || data?.email2 ?
                                    <li className="align-top">
                                        <div className="icon-circle">
                                            <img className="icons svg-js" src={IconEmail} alt="" />
                                        </div>
                                        <div>
                                            {
                                                data?.email ? <p>{prop.lang === 'en' ? 'Email':'ไปรษณีย์อิเล็กทรอนิกส์'} : <a className="link" href={"mailto:" + data?.email}>{data?.email}</a></p> : ''
                                            }
                                            {
                                                data?.email2 ? <p>{prop.lang === 'en' ? 'Correspondence Email':'ไปรษณีย์อิเล็กทรอนิกส์กลางงานสารบรรณ'} : <a className="link" href={"mailto:" + data?.email2}>{data?.email2}</a></p> : ''
                                            }
                                        </div>
                                    </li> : ''
                            }
                        </ul>

                        <div className="py-2">
                            <hr />
                        </div>

                        <h5 className="mb-3">{prop.lang === 'en' ? 'Follow Us':'ติดตามเรา'}</h5>
                        <div className="followus blue-dark">
                            {
                                data?.youtube ? <a href={data?.youtube} target="_blank">
                                    <img className="icons svg-js" src={IconYoutube} alt="HTCR Youtube" />
                                </a> : ''
                            }

                            {
                                data?.facebook ? <a href={data?.facebook} target="_blank">
                                    <img className="icons svg-js" src={IconFacebook} alt="HTCR Facebook" />
                                </a> : ''
                            }

                            {
                                data?.twitter ? <a href={data?.twitter} target="_blank">
                                    <img className="icons svg-js w-16" src={IconTwitter} alt="HTCR X" />
                                </a> : ''
                            }

                            {
                                data?.instagram ? <a href={data?.instagram} target="_blank">
                                    <img className="icons svg-js" src={IconInstagram} alt="HTCR Instagram" />
                                </a> : ''
                            }

                            {
                                data?.linkedin ? <a href={data?.linkedin} target="_blank">
                                    <img className="icons svg-js" src={IconLinkedin} alt="HTCR Linkedin" />
                                </a> : ''
                            }
                        </div>
                    </div>
                </div>
            </div>

            {
                data?.googlemapUrl ?
                    <div className="section p-0">
                        <div className="google-map" data-aos="fade-in">
                            <iframe
                                src={data?.googlemapUrl}
                                width="600" height="450" style={{border: "0px"}} allowFullScreen="" loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div> : ''
            }

        </>
    );
} 